import { Roles } from '../models'
import { useAppSelector } from './store'

export default function useAuth() {
  const ens = useAppSelector((state) => state.ens)
  return {
    isAdmin: ens.rol === Roles.admin,
    isUser: ens.rol === Roles.user,
    hasEnsActiu: ens.ensActiu !== ''
  }
}
